var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.icons),function(item){return _c('div',{key:item.name+item.reference},[(_vm.icon === item.name)?_c('v-icon',{class:item.reference,attrs:{"color":_vm.color,"disabled":_vm.disabled,"size":_vm.size}}):_vm._e()],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }